
import React from 'react';
import { motion } from 'framer-motion';

interface SuggestedQuestionsProps {
  questions: string[];
  onSelectQuestion: (question: string) => void;
}

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({ 
  questions, 
  onSelectQuestion 
}) => {
  return (
    <div className="space-y-4 py-2">
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="text-sm text-gray-500 italic"
      >
        Ask Sparky anything about your investment forms or try one of these:
      </motion.div>
      
      {questions.map((question, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 + (index * 0.2), duration: 0.5 }}
          whileHover={{ scale: 1.02 }}
          className="cursor-pointer bg-[#0a0c1b]/10 hover:bg-[#0a0c1b]/20 p-3 rounded-lg text-sm transition-colors border border-[#0a0c1b]/10"
          onClick={() => onSelectQuestion(question)}
        >
          {question}
        </motion.div>
      ))}
    </div>
  );
};

export default SuggestedQuestions;
